export default __webpack_public_path__ + "static/media/TreeLocations.41553dbe.png";